const loaderHandler = {
  showLoader(id) {
    const loaderElement = document.getElementById(id);
    if (loaderElement) {
      loaderElement.classList.remove('hidden');
    }
  },
  hideLoader(id, delay = 500) {
    const loaderElement = document.getElementById(id);
    setTimeout(() => {
      if (loaderElement) {
        loaderElement.classList.add('hidden');
      }
    }, delay);
  }
};

const fadeInContent = (selector, delay = 300) => {
  const element = document.querySelector(selector);

  if (element) {
    setTimeout(() => {
      element.style.transition = 'opacity 0.5s ease-in-out';
      element.style.opacity = 1;
    }, delay);
  }
};

class HitchFinder {
  constructor(formId, baseApiUrl, formType, language, notMatchText) {
    this.form = document.getElementById(formId);
    this.baseApiUrl = baseApiUrl;
    this.formType = formType;
    this.language = language;
    this.notMatchText = notMatchText;
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.loaderID = 'bm-result-loader';

    // Init dynamic selects
    this.dynamicSelects = new DynamicSelects(baseApiUrl, formType, notMatchText, this);

    // form submit
    this.form.addEventListener('submit', (event) => this.handleFormSubmit(event));

    // disable submit button on start
    this.submitButton.disabled = true;
  }

  handleFormSubmit(event) {
    event.preventDefault();
    const params = this.getFormParams(); //collect form params
    this.fetchResults(params);
  }

  getFormParams() {
    const formData = new FormData(this.form);
    const params = {};

    formData.forEach((value, key) => {
      //check if key is array
      if (key.endsWith('[]')) {
        const cleanKey = key.slice(0, -2);
        if (!params[cleanKey]) {
          params[cleanKey] = [];
        }
        params[cleanKey].push(value);
      } else {
        params[key] = value;
      }
    });

    // check if size select exists
    const sizeSelect = this.form.querySelector('select[name="size"]');
    if (sizeSelect) {
      // check if size is array and add 'A' if not exists
      if (params.size && !Array.isArray(params.size)) {
        params.size = [params.size];
      }
      if (params.size && !params.size.includes('A')) {
        params.size.push('A');
      } else if (!params.size) {
        params.size = ['A'];
      }
    }

    return params;
  }

  // get results from API
  fetchResults(params) {
    const url = this.buildUrl(params);
    loaderHandler.showLoader(this.loaderID);
    this.submitButton.disabled = true;

    document.querySelector('#hf-results-title').classList.remove('hidden');

    fetch(url, {
      headers: {
        'Accept-Language': this.language
      }
    })
        .then(response => response.json())
        .then(data => {
          this.displayResults(data);
          loaderHandler.hideLoader(this.loaderID);
          this.submitButton.disabled = false;
        })
        .catch(error => {
          console.error('Error fetching results:', error);
          this.submitButton.disabled = false;
        });
  }

  // build url based on params
  buildUrl(params) {
    const apiUrl = new URL('/hitch-finder', this.baseApiUrl);
    apiUrl.searchParams.append('type', this.formType);

    Object.keys(params).forEach(key => {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach(val => apiUrl.searchParams.append(`${key}[]`, val));
      } else {
        apiUrl.searchParams.append(key, value);
      }
    });

    return apiUrl.toString();
  }

  displayResults(data) {
    const resultsContainer = document.getElementById('hitch-results-container');
    resultsContainer.innerHTML = ''; // clear previous results

    if (data.length === 0) {
      resultsContainer.innerHTML = '<div>No products found.</div>';
    } else {
      data.forEach(product => {

        const productUrl = this.language !== 'en' ? `/${this.language}/products/${product.url}` : `/products/${product.url}`;
        const productElement = document.createElement('div');
        productElement.classList.add('bm-hf-product', 'col-12', 'col-sm-6');
        productElement.innerHTML = `
          <a class="bm-hf-product__image-wrapper" href="${productUrl}">
            <img class="bm-hf-product__image" src="${product.image}" alt="${product.name}" title="${product.name}">
          </a>
          <div class="bm-hf-product__info">
            <a href="${productUrl}" class="bm-hf-product__name">${product.name}</a>
            <div class="bm-hf-product__sku">Model: ${product.sku}</div>
            <div class="bm-hf-product__price">${product.price}</div>
          </div>
        `;
        resultsContainer.appendChild(productElement);
      });

      if (window.innerWidth < 576) {
        document.getElementById('hf-results').scrollIntoView({behavior: 'smooth'});
      }

    }
  }

  checkAllSelectsFilled() {
    const selects = this.form.querySelectorAll('.dynamic-select');
    for (const select of selects) {
      if (select.disabled || !select.value) {
        return false; // if any select is disabled or empty return false
      }
    }
    return true; // all selects are filled
  }

  enableSubmitButton() {
    if (this.checkAllSelectsFilled()) {
      this.submitButton.disabled = false; // enable submit button
    } else {
      this.submitButton.disabled = true;
    }
  }
}

// Load dynamic options for selects, select management
class DynamicSelects {
  constructor(baseApiUrl, formType, notMatchText, hitchFinder) {
    this.baseApiUrl = baseApiUrl;
    this.formType = formType;
    this.hitchFinder = hitchFinder;
    this.notMatchText = notMatchText;
    this.selectContainer = document.getElementById('select-container');
    this.selects = this.selectContainer.querySelectorAll('.dynamic-select');
    this.init();
  }

  // Init dynamic selects
  init() {
    this.selects.forEach((select, index) => {
      this.addPlaceholderOption(select); // Adding placeholder to select
      if (index > 0) {
        select.disabled = true; // disable select after first one
      }
    });

    this.loadOptions({}, 1); // Load options for first select

    this.selects.forEach((select) => {
      select.addEventListener('change', (event) => this.handleSelectChange(event));
    });
  }

  // adding placeholder option to select
  addPlaceholderOption(select) {
    const placeholderText = select.getAttribute('data-placeholder') || `Select ${select.getAttribute('name')}`;
    const placeholderOption = document.createElement('option');
    placeholderOption.textContent = placeholderText;
    placeholderOption.value = '';
    placeholderOption.disabled = true;
    placeholderOption.selected = true;
    select.insertBefore(placeholderOption, select.firstChild);
  }

  // fetch select options based on params
  loadOptions(params, level) {
    const select = this.selectContainer.querySelector(`[data-level="${level}"]`);
    if (!select) return;

    const endpoint = select.getAttribute('data-endpoint');
    const url = this.buildUrl(endpoint, params);

    fetch(url)
        .then(response => response.json())
        .then(data => {
          if (select) {
            this.populateSelect(select, data);
            select.disabled = false; // enable when options are loaded
            this.hitchFinder.enableSubmitButton(); // check if all selects are filled so submit button can be enabled
          }
        })
        .catch(error => console.error('Error loading options: ', error));
  }

  // build url based on params and endpoint for fetching select options
  buildUrl(endpoint, params) {
    const url = new URL(endpoint, this.baseApiUrl);
    url.searchParams.append('type', this.formType);
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    return url.toString();
  }

  // populate select with options
  populateSelect(select, options) {
    // clear select, leave placeholder only
    while (select.options.length > 1) {
      select.remove(1);
    }

    const format = select.getAttribute('data-format');

    if (format === 'fromTo') {
      options.forEach(range => {
        if (range.from !== undefined && range.to !== undefined) {
          const opt = document.createElement('option');
          opt.value = range.from; // set option value to "from" value
          opt.textContent = `${range.from} - ${range.to} mm`; // option string
          select.appendChild(opt);
        }
      });
    } else if (format === 'threadName') {
      options.forEach(item => {
        const opt = document.createElement('option');
        opt.value = item.thread_name;
        opt.textContent = item.thread_name;
        select.appendChild(opt);
      });
    } else {
      if (Array.isArray(options)) {
        options.forEach(value => {
          if (value !== 'A') { // omit "A" if it is not the only option
            const opt = document.createElement('option');
            opt.value = value;
            if (!isNaN(value)) {
              opt.textContent = `${value} mm`; // add mm unit if number
            } else {
              opt.textContent = value;
            }
            select.appendChild(opt);
          }
        });
      }
    }

    // add not match option, check if data-notmatch attribute is set to true
    if (select.getAttribute('data-notmatch') === 'true') {
      const notMatchOption = document.createElement('option');
      notMatchOption.value = '-1';
      notMatchOption.textContent = this.notMatchText;
      select.appendChild(notMatchOption);
    }
  }


  handleSelectChange(event) {
    const selectedValue = event.target.value;
    const level = parseInt(event.target.getAttribute('data-level'));

    this.clearSelectsAfterLevel(level);
    const params = this.collectParams(level);

    if (selectedValue === '-1') {
      // if selected value is '-1' show form from tally
      const form = document.getElementById('measurement-not-match-btn');
      if (form) {
        form.click();
      }
      return; // stop fetching options
    }

    if (selectedValue && selectedValue !== '-1') {
      params[event.target.getAttribute('name')] = selectedValue;

      const nextLevelSelect = this.selectContainer.querySelector(`[data-level="${level + 1}"]`);
      if (nextLevelSelect) {
        nextLevelSelect.disabled = true; // load options after select change
        this.addPlaceholderOption(nextLevelSelect); // set placeholder
        this.loadOptions(params, level + 1);
      }
    }

    this.hitchFinder.enableSubmitButton();
  }

  // get all params from selects up to current level
  collectParams(currentLevel) {
    const params = {};
    this.selects.forEach(select => {
      const level = parseInt(select.getAttribute('data-level'));
      if (level <= currentLevel && select.value) {
        params[select.getAttribute('name')] = select.value;
      }
    });
    return params;
  }

  // clear selects after changes in previous selects
  clearSelectsAfterLevel(level) {
    this.selects.forEach(select => {
      const selectLevel = parseInt(select.getAttribute('data-level'));
      if (selectLevel > level) {
        select.disabled = true;
        while (select.options.length > 1) {
          select.remove(1);
        }
        this.addPlaceholderOption(select);
      }
    });
  }
}

class SolidAxleTableLoader {
  constructor(drawerBodySelector, viewUrl, dataEndpoint, drawerTitle) {
    this.drawerBodyElement = document.querySelector(drawerBodySelector);
    this.viewUrl = viewUrl;
    this.dataEndpoint = dataEndpoint;
    this.drawer = document.querySelector('[data-side-drawer]');

    // Check if elements exist
    if (!this.drawerBodyElement || !this.drawer) {
      throw new Error('Drawer element or body element not found');
    }

    // Set drawer classes and title
    this.drawer.classList.add('bm-hf-drawer');
    this.drawer.querySelector("[data-drawer-title]").textContent = drawerTitle;
  }

  // Load table and fetch data
  loadTable() {
    // Open the side drawer
    document.body.classList.add("side_Drawer_open");

    // Fetch table template and insert into the drawer
    fetch(this.viewUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to load table view');
          }
          return response.text();
        })
        .then(html => {
          this.drawerBodyElement.innerHTML = html;

          // Fetch data to fill the table
          return fetch(this.dataEndpoint);
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to fetch data from endpoint');
          }
          return response.json();
        })
        .then(data => {
          // Add rows to the appropriate tables
          const addedRowsToDiameter = this.addDiameterTable(data);
          const addedRowsToThreadPitch = this.addThreadPitchTable(data);
          const addedRowsToLength = this.addLengthTable(data);
          const addedRowsToLengthOfThread = this.addLengthOfThreadTable(data);

          // Hide tables if no rows were added
          this.hideEmptyTable('diameter-table', addedRowsToDiameter);
          this.hideEmptyTable('thread-pitch-table', addedRowsToThreadPitch);
          this.hideEmptyTable('length-table', addedRowsToLength);
          this.hideEmptyTable('length-of-thread-table', addedRowsToLengthOfThread);

          loaderHandler.hideLoader('bm-hf-drawer-loader');
          fadeInContent(".bm-hf-drawer__content");
        })
        .catch(error => {
          console.error('There was a problem:', error);
          this.drawerBodyElement.innerHTML = "Loading table failed.";
        });
  }

  // Insert rows into the Diameter table
  addDiameterTable(data) {
    const tableBody = document.querySelector("#diameter-table tbody");
    let rowsAdded = 0;

    if (!tableBody) {
      console.error('Diameter table body not found');
      return rowsAdded;
    }

    data.forEach(rowData => {
      if (rowData.diameter || rowData.diameter_inch) {
        const row = this.createTableRow([
          rowData.thread_name || '-',
          rowData.diameter || '-',
          rowData.diameter_inch || '-'
        ]);
        tableBody.appendChild(row);
        rowsAdded++;
      }
    });

    return rowsAdded; // Return the number of rows added
  }

  // Insert rows into the Thread Pitch table
  addThreadPitchTable(data) {
    const tableBody = document.querySelector("#thread-pitch-table tbody");
    let rowsAdded = 0;

    if (!tableBody) {
      console.error('Thread pitch table body not found');
      return rowsAdded;
    }

    data.forEach(rowData => {
      if (rowData.thread || rowData.threads_per_inch) {
        const row = this.createTableRow([
          rowData.thread_name || '-',
          rowData.thread || '-',
          rowData.threads_per_inch || '-'
        ]);
        tableBody.appendChild(row);
        rowsAdded++;
      }
    });

    return rowsAdded; // Return the number of rows added
  }

  // Insert rows into the Length table
  addLengthTable(data) {
    const tableBody = document.querySelector("#length-table tbody");
    let rowsAdded = 0;

    if (!tableBody) {
      console.error('Length table body not found');
      return rowsAdded;
    }

    data.forEach(rowData => {
      if (rowData.length_mm || rowData.length_in) {
        const row = this.createTableRow([
          rowData.thread_name || '-',
          rowData.length_mm || '-',
          rowData.length_in || '-'
        ]);
        tableBody.appendChild(row);
        rowsAdded++;
      }
    });

    return rowsAdded; // Return the number of rows added
  }

  // Insert rows into the Length of threads table
  addLengthOfThreadTable(data) {
    const tableBody = document.querySelector("#length-of-thread-table tbody");
    let rowsAdded = 0;

    if (!tableBody) {
      console.error('Length of thread table body not found');
      return rowsAdded;
    }

    data.forEach(rowData => {
      if (rowData.length_mm || rowData.length_in) {
        const row = this.createTableRow([
          rowData.thread_name || '-',
          rowData.length_of_thread_mm || '-',
          rowData.length_of_thread_inch || '-'
        ]);
        tableBody.appendChild(row);
        rowsAdded++;
      }
    });

    return rowsAdded; // Return the number of rows added
  }

  // Function to hide table if no rows were added
  hideEmptyTable(tableId, rowsAdded) {
    const table = document.getElementById(tableId);
    if (table && rowsAdded === 0) {
      table.style.display = 'none';
    }
  }

  // Function to create a table row
  createTableRow(cellDataArray) {
    const row = document.createElement('tr');

    // Create cells for the row
    cellDataArray.forEach(cellData => {
      const cell = document.createElement('td');
      cell.textContent = cellData;
      row.appendChild(cell);
    });

    return row;
  }
}

class BmDrawerController {
  constructor(drawerBodySelector, drawerClass) {
    this.drawerBodyElement = document.querySelector(drawerBodySelector);
    this.drawer = document.querySelector('[data-side-drawer]');
    this.drawerClass = drawerClass;
    // Check if elements exist
    if (!this.drawerBodyElement || !this.drawer) {
      throw new Error('Drawer element or body element not found');
    }

    // Initialize event listener for buttons with `data-drawer-template`
    this.initDrawerEvent();
  }

  // Initialize event listener for buttons with data-drawer-template
  initDrawerEvent() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bm-drawer-template]');
      if (button) {
        const templateUrl = button.getAttribute('data-bm-drawer-template');
        const drawerTitle = button.getAttribute('data-bm-drawer-title');

        this.loadContent(templateUrl, drawerTitle, this.drawerClass);
      }
    });
  }

  // Method to load content based on the template URL
  loadContent(templateUrl, drawerTitle, drawerClass) {
    // Set drawer title
    this.drawer.classList.add(drawerClass);
    this.drawer.querySelector("[data-drawer-title]").textContent = drawerTitle;

    // Open the side drawer
    document.body.classList.add("side_Drawer_open");

    // Show loader while loading content
    loaderHandler.showLoader('bm-hf-drawer-loader');

    // Fetch the template and insert it into the drawer
    fetch(templateUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to load content');
          }
          return response.text();
        })
        .then(html => {
          // Insert the fetched HTML into the drawer body
          this.drawerBodyElement.innerHTML = html;

          // Hide loader and apply fade-in effect
          loaderHandler.hideLoader('bm-hf-drawer-loader');
          fadeInContent(".bm-hf-drawer__content");
        })
        .catch(error => {
          console.error('There was a problem:', error);
          this.drawerBodyElement.innerHTML = "Loading failed.";
        });
  }
}

// Example usage
// Toogle specs for mobile
document.addEventListener('DOMContentLoaded', () => {
  const toggleElement = document.querySelector('[data-toggle="bm-specs-toggle"]');
  const specsElement = document.querySelector('.bm-specs');

  if (toggleElement && specsElement) {
    toggleElement.addEventListener('click', function () {
      specsElement.classList.toggle('is-visible');
      this.classList.toggle('is-active');
    });
  }
});
